import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import css from './ApxViewReport.module.css'
import cssCommon from './Common.module.css'
import logo from "./../Images/APX.png";
import Grid from '@material-ui/core/Grid';
import MenuReports from '../Components/MenuReports'
import Reports from './Reports'


class ApxViewReport extends Component {
  
  render() {
    return (
      <div>
        <Paper className={css.paper} elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <img src={logo} alt="logo" className={css.logo}></img>
            </Grid>
            <Grid item xs={2}>
              
            </Grid>
            <Grid item xs={8}>
              <MenuReports data={this.props.data}></MenuReports>
            </Grid>
          </Grid>
          <div className={cssCommon.separator}></div>
          <Reports data={this.props.data}></Reports>
        </Paper>
      </div>
    );
  }
}

export default ApxViewReport;